const logout = (phoneNumber, password) => {
	localStorage.clear();
	window.location = '/';
};
export default logout;
